<script setup>
import { ref, computed } from 'vue';

// 이미지 import (QuickMenu.vue와 동일한 경로 사용)
import ImgSajupuri from '@/assets/images_manse/main/img_main-reading-sm.png';
import ImgNangmaniljin from '@/assets/images_manse/main/img_main-saju-sm.png';
import ImgSunghyang from '@/assets/images_manse/main/img_main-personality-sm.png';
import ImgYongshin from '@/assets/images_manse/main/img_main-payment-sm-new.png';

// SVG 아이콘 import (Vite에서 URL로 사용하려면 ?url 필요)
import IconDaeun from '@/assets/images/quick-menu/icon_daeun.svg?url';
import IconDaeunActive from '@/assets/images/quick-menu/icon_daeun_active.svg?url';
import IconOhaengdo from '@/assets/images/quick-menu/icon_ohaengdo.svg?url';
import IconOhaengdoActive from '@/assets/images/quick-menu/icon_ohaengdo_active.svg?url';
import IconSinsal from '@/assets/images/quick-menu/icon_sinsal.svg?url';
import IconSinsalActive from '@/assets/images/quick-menu/icon_sinsal_active.svg?url';

const props = defineProps({
  // 일간 한자 (프로필 아이콘에 표시)
  ilganValue: {
    type: String,
    default: '庚',
  },
  // 일간 오행 색상 클래스
  ilganColorClass: {
    type: String,
    default: 'five04',
  },
  // 현재 선택된 메뉴 (v-model:activeMenu 지원)
  activeMenu: {
    type: String,
    default: 'daeun',
  },
});

const emit = defineEmits(['menuClick', 'update:activeMenu']);

// 메뉴 아이템 정의
const menuItems = [
  // [HIDDEN] 일간특성, 사주풀이, 낭만일진 - 추후 필요 시 주석 해제
  // {
  //   id: 'ilgan',
  //   label: '일간특성',
  //   type: 'ilgan', // 일간 한자 표시
  // },
  // {
  //   id: 'sajupuri',
  //   label: '사주풀이',
  //   icon: ImgSajupuri,
  //   gradient: 'linear-gradient(180deg, #E2E6FF 0%, #C0BEFF 100%)',
  //   borderColor: 'rgba(133, 121, 226, 0.5)',
  // },
  // {
  //   id: 'nangmaniljin',
  //   label: '낭만일진',
  //   icon: ImgNangmaniljin,
  //   gradient: 'linear-gradient(180deg, #FFFDDF 0%, #FFE089 100%)',
  //   borderColor: 'rgba(255, 191, 0, 0.5)',
  // },
  {
    id: 'nangmansunghyang',
    label: '성향분석',
    icon: ImgSunghyang,
    gradient: 'linear-gradient(180deg, #FFF3EF 0%, #FFC1A5 100%)',
    borderColor: 'rgba(244, 122, 73, 0.5)',
  },
  {
    id: 'yongshin',
    label: '용신분석',
    icon: ImgYongshin,
    gradient: 'linear-gradient(180deg, #F1F6FF 0%, #B4D0FF 100%)',
    borderColor: 'rgba(104, 160, 255, 0.5)',
  },
  {
    id: 'daeun',
    label: '대운',
    type: 'icon',
    iconName: 'daeun',
  },
  {
    id: 'ohaengdo',
    label: '오행도',
    type: 'icon',
    iconName: 'ohaengdo',
  },
  {
    id: 'sinsal',
    label: '신살',
    type: 'icon',
    iconName: 'sinsal',
  },
];

const handleMenuClick = (menuId) => {
  // 탭 전환 메뉴 (대운, 오행도, 신살)는 activeMenu 업데이트
  if (['daeun', 'ohaengdo', 'sinsal'].includes(menuId)) {
    emit('update:activeMenu', menuId);
  }
  emit('menuClick', menuId);
};
</script>

<template>
  <div class="mobile-quick-menu">
    <div class="mobile-inner-wrap">
    <div class="mobile-quick-menu__scroll">
      <div
        v-for="item in menuItems"
        :key="item.id"
        class="mobile-quick-menu__item"
        :class="{ active: activeMenu === item.id }"
        @click="handleMenuClick(item.id)"
      >
        <!-- 일간 한자 타입 -->
        <div
          v-if="item.type === 'ilgan'"
          class="mobile-quick-menu__icon ilgan-icon"
          :class="ilganColorClass"
        >
          <span class="ilgan-text">{{ ilganValue }}</span>
        </div>

        <!-- 이미지 타입 (사주풀이, 낭만일진, 낭만성향, 용신분석) -->
        <div v-else-if="item.icon" class="mobile-quick-menu__icon image-icon">
          <img :src="item.icon" :alt="item.label" />
        </div>

        <!-- 아이콘 타입 (대운, 오행도, 신살) -->
        <div
          v-else-if="item.type === 'icon'"
          class="mobile-quick-menu__icon icon-type"
          :class="{ 'icon-active': activeMenu === item.id }"
        >
          <!-- 대운 아이콘 -->
          <template v-if="item.iconName === 'daeun'">
            <img v-if="activeMenu === item.id" :src="IconDaeunActive" alt="대운" />
            <img v-else :src="IconDaeun" alt="대운" />
          </template>
          <!-- 오행도 아이콘 -->
          <template v-else-if="item.iconName === 'ohaengdo'">
            <img v-if="activeMenu === item.id" :src="IconOhaengdoActive" alt="오행도" />
            <img v-else :src="IconOhaengdo" alt="오행도" />
          </template>
          <!-- 신살 아이콘 -->
          <template v-else-if="item.iconName === 'sinsal'">
            <img v-if="activeMenu === item.id" :src="IconSinsalActive" alt="신살" />
            <img v-else :src="IconSinsal" alt="신살" />
          </template>
        </div>

        <!-- 체크 뱃지 (활성화 시 아이콘 우하단에 표시) -->
        <span
          v-if="activeMenu === item.id && item.type === 'icon'"
          class="mobile-quick-menu__check-badge"
        >
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
            <path
              d="M20 6L9 17L4 12"
              stroke="#fff"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>

        <!-- 라벨 -->
        <div class="mobile-quick-menu__label" :class="{ active: activeMenu === item.id }">
          {{ item.label }}
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.mobile-quick-menu {
  background: #f5f5f5;
  padding: 0 0 24px 0;
  overflow: visible;

  &__scroll {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    padding: 0 16px;
  }

  &__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    position: relative;
  }

  // 체크 뱃지 (아이콘 우하단)
  &__check-badge {
    position: absolute;
    right: calc(50% - 26px);
    top: 36px;
    width: 14px;
    height: 14px;
    border-radius: 7px;
    background: #eb4c10;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #f5f5f5;
  }

  &__icon {
    width: 48px;
    height: 48px;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    // 일간 아이콘
    &.ilgan-icon {
      background: linear-gradient(180deg, #c9c9c9 0%, #979797 100%);
      border: 1px solid rgba(118, 118, 118, 0.5);

      .ilgan-text {
        font-size: 22px;
        color: #fff;
        text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
        line-height: 22px;
      }

      // 오행 색상
      &.five01 {
        background: linear-gradient(180deg, #ff8a8a 0%, #c23535 100%);
        border-color: rgba(194, 53, 53, 0.5);
      }
      &.five02 {
        background: linear-gradient(180deg, #6b6b6b 0%, #404040 100%);
        border-color: rgba(64, 64, 64, 0.5);
      }
      &.five03 {
        background: linear-gradient(180deg, #8fcf4f 0%, #5e9f1c 100%);
        border-color: rgba(94, 159, 28, 0.5);
      }
      &.five04 {
        background: linear-gradient(180deg, #c9c9c9 0%, #979797 100%);
        border-color: rgba(118, 118, 118, 0.5);
      }
      &.five05 {
        background: linear-gradient(180deg, #ffcf5c 0%, #db9823 100%);
        border-color: rgba(219, 152, 35, 0.5);
      }
    }

    // 이미지 아이콘 (이미지 자체에 원형 배경 포함)
    &.image-icon {
      background: transparent;
      border: none;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    // 일반 아이콘 타입 (대운, 오행도, 신살)
    &.icon-type {
      background: #fff;
      border: 1px solid #ebebeb;

      img {
        width: 28px;
        height: 28px;
      }

      &.icon-active {
        background: #fff8f5;
        border: 2px solid #eb4c10;
      }
    }
  }

  &__label {
    font-size: 12px;
    font-weight: 500;
    color: #575757;
    line-height: 16px;
    text-align: center;
    white-space: nowrap;

    &.active {
      font-weight: 700;
      color: #eb4c10;
    }
  }
}
</style>
